import _default from './Confirm';
export { _default as default };